<template>
  <b-modal v-model="showModal" centered scrollable hide-header ok-only size="md" @ok="handleOk">
    <template #modal-ok> Done </template>
    <TipTap
      :content="content"
      :editable="false"
      image-extension
      colour-extension
      user-details-extension
      editor-height="250px"
    />
  </b-modal>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import TipTap from '@/components/TipTap/TipTap.vue'
import { useUserDetailsStore } from '@/store/public/userDetails'

const components = {
  TipTap,
}

@Component({ components })
export default class UserDetailsModal extends Vue {
  userDetailsStore = useUserDetailsStore()

  get appLoaded() {
    return this.$typedStore.activeVisualisation.visualisationStore.app.appLoaded
  }

  get showModal() {
    return this.userDetailsStore.modalVisible
  }

  set showModal(newValue) {
    this.userDetailsStore.showModal(newValue)
  }

  get content() {
    return this.$typedStore.primary.app.config.userDetails.content
  }

  async handleOk() {
    this.userDetailsStore.saveAnswers()
  }
}
</script>
